/** @format */

import { TextField, MenuItem, Select, FormControl } from "@mui/material";
import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Row } from "react-bootstrap";
import Col from "react-bootstrap/cjs/Col";

import { Formik, Form } from "formik";

// import { FaAngleDown } from "react-icons/fa";
import DialogContentText from "@mui/material/DialogContentText";
// import { components } from "react-select";
// import Waba from "../../dao/Waba";
import Approval from "../../dao/Approval";
import swal from "../../reusables/CustomSwal";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// const TABLE_HEAD = [
//   { id: "count", label: "No.", alignRight: false, sortable: false },
//   { id: "waba_id", label: "WABA ID", alignRight: false, sortable: true },
//   // {id: 'role', label: 'Role', alignRight: false, sortable: true},
// ];

// const DropdownIndicator = (props) => {
//   return (
//     components.DropdownIndicator && (
//       <components.DropdownIndicator {...props}>
//         <FaAngleDown color={"grey"} />
//       </components.DropdownIndicator>
//     )
//   );
// };

export default function UpdateApprovalMasterDialog(props) {
  let user = useSelector(({ auth }) => auth.auth);
  const navigate = useNavigate();

  const { open, onClose, details } = props;

  const [initData, setInitData] = useState({
    user_id: "",
    waba_id: "",
    approval_by: 0,
    status: "",
  });
  // console.log("initData", initData);

  React.useEffect(() => {
    setInitData({
      ...initData,
      user_id: details.user_id,
      waba_id: details.waba_id,
      status: details.status,
    });
  }, [details, initData]);

  // const [wabaId, setWabaId] = useState(null);
  // const [wabaName, setWabaName] = useState(null);
  // const [wabaDesc, setWabaDesc] = useState(null);
  // const [wabaIndustry, setWabaIndustry] = useState("none");
  // const [wabaWebsite, setWabaWebsite] = useState(null);

  // const reset = () => {
  //   setWabaId(null);
  // };

  const onSubmit = async (values) => {
    let data = {
      user_id: values.user_id,
      waba_id: values.waba_id,
      status: values.status,
      approval_by: user.id,
    };
    try {
      swal
        .fire({
          title: "",
          text: "Are you sure you want to edit this item?",
          icon: "warning",
          showCancelButton: true,
          confirmButton: "Yes",
          confirmButtonColor: "#3085d6",
          cancelButton: "Cancel",
          // cancelButtonColor: '#d33',
        })
        .then(async (result) => {
          try {
            if (result.isConfirmed) {
              let res = await Approval.updateApproval(data, details.id);
              if (res.id || res.success) {
                await swal.fire({
                  title: "",
                  text: "Creation Successful",
                  icon: "success",
                });
              }
              handleClose(true);
            } else {
              await swal.fire({
                title: "",
                text: "Creation Failed",
                icon: "error",
              });
            }
          } catch (e) {
            console.error(e);
            await swal.fire({
              title: "",
              text: "Phone Number has been used",
              icon: "error",
            });
          }
          await navigate(0);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const reset = () => {
    // setWabaId(null);
  };

  const handleClose = (refresh) => {
    reset();
    onClose(refresh);
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={() => onClose()}
      >
        <Formik
          enableReinitialize
          // validationSchema={FormSubmission1Schema}
          initialValues={initData}
          onSubmit={(values) => {
            onSubmit(values);
          }}
        >
          {(props) => {
            const { values, handleChange } = props;
            return (
              <Form>
                <DialogTitle>Edit Approval</DialogTitle>
                <DialogContent>
                  <DialogContentText>USER ID</DialogContentText>
                  <Row>
                    <Col md={12}>
                      <TextField
                        name="user_id"
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        value={values.user_id}
                        onChange={handleChange}
                        fullWidth
                        placeholder={"USER ID"}
                        InputLabelProps={{ shrink: true }}
                        disabled
                      />
                    </Col>
                  </Row>

                  <Row>
                    <DialogContentText>WABA ID</DialogContentText>
                    <TextField
                      name="waba_id"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      onChange={handleChange}
                      value={values.waba_id}
                      fullWidth
                      placeholder={"WABA ID"}
                      inputLabelProps={{ shrink: true }}
                      disabled
                    />
                  </Row>

                  <Row>
                    <DialogContentText>Cost Business Utility</DialogContentText>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="status"
                        value={values.status}
                        label="Status"
                        onChange={handleChange}
                      >
                        <MenuItem value={"approved"}>Approved</MenuItem>
                        <MenuItem value={"not approve"}>Not Approve</MenuItem>
                        <MenuItem value={"pending"}>Pending</MenuItem>
                      </Select>
                    </FormControl>
                  </Row>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button type="submit">Edit</Button>
                </DialogActions>
              </Form>
            );
          }}
        </Formik>
      </Dialog>
    </>
  );
}
